// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ifji","inputWrap":"Table_inputWrap__3MiT7","col":"Table_col__23l-S","bmiTooltip":"Table_bmiTooltip__3m_1N"};